<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
    <rect x="44" y="24" width="41" height="43" transform="translate(129 91) rotate(-180)" fill="#fff" stroke="#6576ff"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    <path
        d="M71,37V33.6A1.6,1.6,0,0,0,69.4,32H54.6A1.6,1.6,0,0,0,53,33.6V48.39A1.61,1.61,0,0,0,54.61,50H69.4A1.6,1.6,0,0,0,71,48.4V37Z"
        fill="#eff1ff" />
    <line x1="60" y1="42" x2="60" y2="45" fill="none" stroke="#6576ff" stroke-width="1.5" />
    <line x1="58" y1="46" x2="56" y2="46" fill="none" stroke="#6576ff" stroke-width="1.5" />
    <rect x="64" y="35" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5" />
    <rect x="56" y="35" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5" />
    <rect x="64" y="42" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5" />
    <polyline points="58 42 56 42 56 44" fill="none" stroke="#6576ff" stroke-width="1.5" />
    <path d="M48,53H78a0,0,0,0,1,0,0v9a0,0,0,0,1,0,0H48a2,2,0,0,1-2-2V55a2,2,0,0,1,2-2Z"
        transform="translate(124 115) rotate(-180)" fill="#e3e7fe" />
    <circle cx="70" cy="28" r="0.5" fill="none" stroke="#33d895" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <circle cx="75" cy="28" r="0.5" fill="none" stroke="#f4bd0e" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <circle cx="80" cy="28" r="0.5" fill="none" stroke="#eb6459" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <rect x="5" y="9" width="40" height="72" rx="3" ry="3" fill="#e3e7fe" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <rect x="9" y="22" width="32" height="43" fill="#fff" />
    <polyline points="31 34 35 34 35 38" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <polyline points="19 54 15 54 15 50" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <polyline points="15 38 15 34 19 34" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <polyline points="35 50 35 54 31 54" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <line x1="25" y1="41" x2="25" y2="47" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <line x1="22" y1="44" x2="28" y2="44" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <circle cx="25" cy="74" r="3" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
    <line x1="23" y1="15" x2="28" y2="15" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="2" />
</svg>